import { IsBoolean, IsInt, IsOptional, IsString, Max, Min } from 'class-validator';

/**
 * Supersampling render scale: frames are rendered at Nx device scale and source
 * assets fetched at Nx resolution, then downscaled, for sharper output. 1 = off.
 * The encoder clamps to the same ceiling (MAX_SUPERSAMPLE_FACTOR) and to its
 * pixel budget regardless of what is stored here.
 */
export const MIN_RENDER_SCALE = 1;
export const MAX_RENDER_SCALE = 3;

/**
 * Default render scale seeded onto NEW templates by the frontend creation factory only.
 * The backend render path never assumes a default (the transformer omits renderScale when
 * unset), so pre-existing/legacy templates keep rendering at 1x and never adopt this.
 */
export const DEFAULT_NEW_TEMPLATE_RENDER_SCALE = 2;

export class AdvancedConfigDto {
	/** Explicit site-wide sharing; missing values keep unassigned templates private. */
	@IsOptional()
	@IsBoolean()
	sharedWithEveryone?: boolean;

	@IsOptional()
	@IsBoolean()
	disableCustomSizes?: boolean;

	/**
	 * Supersampling factor for export (1 = off, 2/3 = render at Nx then downscale).
	 * Omitted/undefined renders at 1x: the encoder honours only an explicit integer in
	 * [MIN_RENDER_SCALE, MAX_RENDER_SCALE] and falls back to 1x for anything else.
	 */
	@IsOptional()
	@IsInt()
	@Min(MIN_RENDER_SCALE)
	@Max(MAX_RENDER_SCALE)
	renderScale?: number;

	/** Legacy display flag, read only when the template-owned configuration is absent. */
	@IsOptional()
	@IsBoolean()
	enableCustomContent?: boolean;

	@IsOptional()
	@IsBoolean()
	adSizeManagerCustomContentEnabled?: boolean;

	@IsOptional()
	@IsString()
	adSizeManagerCustomContent?: string | null;
}
